import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Card } from "antd";
import moment from "moment";
import _ from "lodash";
import * as actions from "../../store/actions/index";
import axiosBackEnd from "../../config/axios/axios-back-end";
import { mypRoles } from "../../utils/mappingData";
import FormOne from "../../components/AdvanceSearch/User/FormOne";
import TableOne from "../../components/AdvanceSearch/User/TableOne";
// import { mypRoles } from "../../../";

const mypRolesKey = _.keyBy(mypRoles, "id");

const cardStyle = { borderRadius: "20px" };

class UserManager extends Component {
  formOneFormRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      dataOne: null,
      dataTwo: [],
      firstLoad: true,
    };
    this.child = React.createRef();
  }

  async componentDidMount() {
    await this.getDataOne();
  }

  getDataOne = async (data) => {
    const { apiStart, apiComplete } = this.props;
    apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.get("/api/hotels/list", {
        params: data,
        headers,
      });
      if (response && response.data) {
        if (response.data.data) {
          await this.setState({ dataOne: response.data.data });
        }
      }
      apiComplete();
    } catch (err) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      apiComplete();
      console.log("Eroor: ", err);
    }
  };

  getDataTwo = async (data) => {
    const { apiStart, apiComplete } = this.props;
    apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.post("/api/users/advance/search", data, {
        headers,
      });
      if (response.data && response.data.data) {
        const newData = [];
        response.data.data.forEach((e) => {
          const newItem = { ...e };
          newItem.main_role = e?.main_role?.main_role_name ?? null;
          newItem.role = e?.role?.role_name ?? null;
          if (e.status) {
            if (e.welcome_reset_status) {
              newItem.status = "Active";
            } else if (e.user_invitation_sent && e.user_invitation_sent_date && moment().isBefore(moment(e.user_invitation_sent_date).add(48, "hours"))) {
              newItem.status = "Pending";
            } else {
              newItem.status = "Created";
            }
          } else {
            newItem.status = "Inactive";
          }
          newItem.custom_permission = e.custom_permission
            ? "Enable"
            : "Disable";
          newItem.use_mfa = e.use_mfa ? "Enable" : "Disable";
          newItem.myp_role =
            e.myp_role &&
              mypRolesKey &&
              mypRolesKey[e.myp_role] &&
              mypRolesKey[e.myp_role].name
              ? mypRolesKey[e.myp_role].name
              : null;
          newItem.hotels_new = e.hotels ? e.hotels.map((hotel) => {

            return (
              hotel.hotel.hotel_code +
              " - " +
              hotel.hotel.hotel_name +
              " -  " +
              hotel.hotel.primary_hmg_id.hmg_id.hmg_name +
              " - " +
              hotel.hotel.primary_hmg_id.project_name +
              // `${hotel?.hotel?.secondary_hmg_id?.hmg_id?.hmg_name ? " , " + hotel.hotel.secondary_hmg_id.hmg_id.hmg_name : ""}` +
              `${hotel?.hotel?.secondary_hmg_id?.project_name ? " , " + hotel.hotel.secondary_hmg_id?.project_name : ""}` +
              // `${hotel?.hotel?.third_hmg_id?.hmg_id?.hmg_name ? " , " + hotel.hotel.third_hmg_id.hmg_id.hmg_name : ""}` +
              `${hotel?.hotel?.third_hmg_id?.project_name ? " , " + hotel.hotel.third_hmg_id?.project_name : ""}` +
              // `${hotel?.hotel?.fourth_hmg_id?.hmg_id?.hmg_name ? " , " + hotel.hotel.fourth_hmg_id.hmg_id.hmg_name : ""}` +
              `${hotel?.hotel?.fourth_hmg_id?.project_name ? " , " + hotel.hotel.fourth_hmg_id?.project_name : ""}`
            );
          }).join("\n") : "";
          newItem.create_by = e?.create_by?.name ?? null;
          newItem.create_at = e.create_at
            ? moment(e.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : null;
          newItem.update_by = e?.update_by?.name ?? null;
          newItem.update_at = e.update_at
            ? moment(e.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : null;
          newData.push(newItem);
        });
        this.setState({ dataTwo: null });
        this.setState({ dataTwo: newData, firstLoad: false });
      } else {
        console.log("Eroor: ", response);
      }
      apiComplete();
    } catch (err) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      apiComplete();
      console.log("Eroor: ", err);
    }
  };

  formOneOnFinish = async (data) => {
    await this.getDataTwo(data);
  };

  exportOnClick = () => {
    this.child.current.exportOnClick();
  };

  render() {
    const { api } = this.props;
    const { dataOne, dataTwo, firstLoad } = this.state;
    return (
      <div>
        <div className="container_ab">
          {dataOne ? (
            <div className="container_style_2">
              <h2 className="titleStyles">Advanced User Management</h2>
              <Card style={cardStyle}>
                <FormOne
                  formRef={this.formOneFormRef}
                  dataOne={dataOne}
                  dataTwo={dataTwo}
                  formOneOnFinish={this.formOneOnFinish}
                  exportOnClick={this.exportOnClick}
                />
                {dataTwo ? (
                  <TableOne
                    tableOneData={dataTwo}
                    firstLoad={firstLoad}
                    permission={api.permission}
                    ref={this.child}
                  />
                ) : null}
              </Card>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  apiStart: (data) => dispatch(actions.apiStart(data)),
  apiComplete: (data) => dispatch(actions.apiComplete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManager);
